import { Provider } from "react-redux";
import { AuthProvider } from "../context/authContext";
import { CourseProvider } from "../context/courseHoursContext";
import { LocationProvider } from "../context/locationContext";
import { StudentClassesProvider } from "../context/StudentClassesContext";
import { TimetableProvider } from "../context/timetableContext";
import { HelmetProvider } from "react-helmet-async";
import Store from "../Store"
import { BrowserRouter } from "react-router-dom";

export default function AppProviders({ children }) {
    return (
      <Provider store={Store}>
       <BrowserRouter>
        <LocationProvider>
          <AuthProvider>
            <TimetableProvider>
              <StudentClassesProvider>
                <CourseProvider>
                  <HelmetProvider>
                    {children}
                  </HelmetProvider>
                </CourseProvider>
              </StudentClassesProvider>
            </TimetableProvider>
          </AuthProvider>
        </LocationProvider>
       </BrowserRouter>
      </Provider>
    );
  }
  